'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionalBundleOffers = exports.standardBundleOffers = undefined;

var _standardBundleOffers, _INDIA, _BRAZIL;

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BundledOfferIds = (0, _keyMirror2.default)({
  MARKETING_HUB_STARTER: null,
  SALES_HUB_STARTER: null,
  SERVICE_HUB_STARTER: null,
  GROWTH_SUITE_STARTER: null,
  INDIA_PROMO_MARKETING_STARTER: null,
  INDIA_PROMO_SALES_STARTER: null,
  INDIA_PROMO_SERVICE_STARTER: null,
  INDIA_PROMO_SALES_PROFESSIONAL: null,
  INDIA_PROMO_SERVICE_PROFESSIONAL: null,
  INDIA_PROMO_MARKETING_PROFESSIONAL: null,
  BRAZIL_PROMO_MARKETING_STARTER: null,
  BRAZIL_PROMO_SALES_STARTER: null,
  BRAZIL_PROMO_SERVICE_STARTER: null,
  BRAZIL_PROMO_SALES_PROFESSIONAL: null,
  BRAZIL_PROMO_SERVICE_PROFESSIONAL: null
});

var standardBundleOffers = exports.standardBundleOffers = (_standardBundleOffers = {}, _defineProperty(_standardBundleOffers, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, BundledOfferIds.MARKETING_HUB_STARTER), _defineProperty(_standardBundleOffers, MerchandiseIds.PRODUCT_SALES_STARTER, BundledOfferIds.SALES_HUB_STARTER), _defineProperty(_standardBundleOffers, MerchandiseIds.PRODUCT_SERVICE_STARTER, BundledOfferIds.SERVICE_HUB_STARTER), _standardBundleOffers);

var promotionalBundleOffers = exports.promotionalBundleOffers = {
  INDIA: (_INDIA = {}, _defineProperty(_INDIA, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, BundledOfferIds.INDIA_PROMO_MARKETING_STARTER), _defineProperty(_INDIA, MerchandiseIds.PRODUCT_SALES_STARTER, BundledOfferIds.INDIA_PROMO_SALES_STARTER), _defineProperty(_INDIA, MerchandiseIds.PRODUCT_SERVICE_STARTER, BundledOfferIds.INDIA_PROMO_SERVICE_STARTER), _defineProperty(_INDIA, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, BundledOfferIds.INDIA_PROMO_MARKETING_PROFESSIONAL), _defineProperty(_INDIA, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, BundledOfferIds.INDIA_PROMO_SALES_PROFESSIONAL), _defineProperty(_INDIA, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, BundledOfferIds.INDIA_PROMO_SERVICE_PROFESSIONAL), _INDIA),
  BRAZIL: (_BRAZIL = {}, _defineProperty(_BRAZIL, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, BundledOfferIds.BRAZIL_PROMO_MARKETING_STARTER), _defineProperty(_BRAZIL, MerchandiseIds.PRODUCT_SALES_STARTER, BundledOfferIds.BRAZIL_PROMO_SALES_STARTER), _defineProperty(_BRAZIL, MerchandiseIds.PRODUCT_SERVICE_STARTER, BundledOfferIds.BRAZIL_PROMO_SERVICE_STARTER), _defineProperty(_BRAZIL, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, BundledOfferIds.BRAZIL_PROMO_SALES_PROFESSIONAL), _defineProperty(_BRAZIL, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, BundledOfferIds.BRAZIL_PROMO_SERVICE_PROFESSIONAL), _BRAZIL)
};


//////////////////
// WEBPACK FOOTER
// ./js/constants/BundledOffers.js
// module id = 430
// module chunks = 3 4 5